import localData from './localData';
import { USER_DATA } from 'shared/constants/users';
import { Privilege, PrivilegeStatus } from 'shared/constants/privilege';

export const getCurrentUsername = () => {
  return localData.get(USER_DATA.USERNAME) || '';
};

export const isCurrentUserTaskManager = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return (
    privilege[Privilege.ORGANIZATION_TASK_MANAGEMENT] === PrivilegeStatus.ON
  );
};

export const isCurrentUserTaskManagerKenshin = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return (
    privilege[Privilege.ORGANIZATION_TASK_MANAGEMENT_KENSHIN] ===
    PrivilegeStatus.ON
  );
};

export const isCurrentUserOrganizationManager = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return privilege[Privilege.ORGANIZATION_MANAGEMENT] === PrivilegeStatus.ON;
};

export const isCurrentUserPicAsDoctor = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return privilege[Privilege.PERSON_IN_CHARGE_AS_DOCTOR] === PrivilegeStatus.ON;
};

export const getAllTaskMangers = () => {
  return [];
};

export const getAllOrganizationMangers = () => {
  return [];
};

export const getAllPicAsDoctors = () => {
  return [];
};

export const doesUserHaveAiSummaryPrivilege = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return privilege[Privilege.AI_SUMMARY] === PrivilegeStatus.ON;
};

export const doesUserHaveHistoryPrivilege = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return (
    privilege[Privilege.ORGANIZATION_TASK_LIST] === PrivilegeStatus.ON ||
    privilege[Privilege.ORGANIZATION_TASK_LIST_KENSHIN] === PrivilegeStatus.ON
  );
};

export const doesUserHaveKenshinHistoryPrivilege = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return (
    privilege[Privilege.ORGANIZATION_TASK_LIST_KENSHIN] === PrivilegeStatus.ON
  );
};

export const doesUserHaveSeimitsuHistoryPrivilege = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return privilege[Privilege.ORGANIZATION_TASK_LIST] === PrivilegeStatus.ON;
};

export const doesUserHaveOrganizationTaskListPrivilege = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return privilege[Privilege.ORGANIZATION_TASK_LIST] === PrivilegeStatus.ON;
};

export const doesUserHaveSeimitsuViewerPrivilege = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return privilege[Privilege.SEIMITSU_VIEWER] === PrivilegeStatus.ON;
};

export const doesUserHaveSeimitsuIssueDeletionPrivilege = () => {
  const privilege = JSON.parse(
    localData.get(USER_DATA.CURRENT_PRIVILEGE) || '{}'
  );

  return privilege[Privilege.SEIMITSU_ISSUE_DELETION] === PrivilegeStatus.ON;
};
